import { TfiClose } from "react-icons/tfi";
import { AiFillSetting } from "react-icons/ai";
import { AiOutlineCaretDown } from "react-icons/ai";
import "./style.css";
import useAppAccessor from "../../../../hooks/useappAccessor";
import {
  getBrandColor,
  REGISTRATION_PARTNER_CO_COLOR,
} from "../../../../utils/brand.util";
import { removeItem } from "../../../../lib/storage";
import useAppNavigation from "../../../../hooks/useAppNavigation";
import { useEffect, useState } from "react";
import {
  hideSettingPage,
  showAttendeeCountFunc,
} from "../../../agora-live/components/streamControls/controls.actions";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { linksConstants } from "../../../../constants";
import { setStramState } from "../../../live-main/livemain.actions";
import MediaDeviceTest from "../../../agora-live/components/avDetector";

const SettingsScreen = () => {
  const { navigate } = useAppNavigation();
  const { getLiveMainData, getUserData } = useAppAccessor();
  const { user, client } = getUserData();
  const { configurationData } = getLiveMainData();
  const [isShowTitle, setIsShowTitle] = useState(true);
  const { language } = getUserData();

  const { host_fullname, host_picture } = configurationData;
  const dispatch = useAppDispatch();
  const { publicUserData } = user;

  const settingsBrandColor =
    client === "partner.co" ? REGISTRATION_PARTNER_CO_COLOR : getBrandColor(client);

  const logoutWeb = async () => {
    await dispatch(setStramState('ended'));
    //TODO: To be reviewed
    // removeItem("jwt_token");
    
   // console.log("logoutWeb");
    navigate({ screen: "/login" });
  };

  const handleSwitchChange = () => {
    dispatch(showAttendeeCountFunc(!isShowTitle));
    setIsShowTitle(!isShowTitle);
  };
  
  const handleEmailShare = () => {
    const emailSubject = encodeURIComponent("Support");

    const mailtoLink = `mailto:support@hussle.tech?subject=${emailSubject}`;
    const windowWidth = 500;
    const windowHeight = 500;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    const leftPosition = (screenWidth - windowWidth) / 2;
    const topPosition = (screenHeight - windowHeight) / 2;

    const mailtoWindow = window.open(
    mailtoLink,
    'Hussle Support',
    `width=${windowWidth},height=${windowHeight},left=${leftPosition},top=${topPosition},resizable=yes`
    );
  }

  const openNewTab = (url: string) => {
    window.open(url, '_blank');
  }


  return (
    <div className=" settingContainer">
      <div className="h-full w-full relative ">
        <div
          className="h-full w-full flex flex-col "
          style={{ backgroundColor: "#181818" }}
        >
          <div className="flex w-full justify-between px-3 h-10 pt-3 items-center">
            <div className="h-2.5 w-2.5"></div>
            <TfiClose
              color="#DEDEDE"
              size={20}
              cursor="pointer"
              onClick={() => dispatch(hideSettingPage())}
            />
          </div>
          <div className="flex px-3 mt-2.5">
            <div className="flex h-9 w-9 items-center justify-center bg-[#222324] rounded-md">
              <AiFillSetting color="#ffffff" size={20}  />
            </div>
            <div>
              <span className="text-[#DEDEDE] text-[26px] ml-2.5 ">
                {language['settings']}
              </span>
            </div>
          </div>
          <div className="flex w-full pl-2 pr-2  mt-5">
            <div className="flex bg-[#222324] w-full rounded pl-3 pr-3 pt-4 pb-4">
              <div className="rounded-full h-14 w-14">
                <img
                  src={
                    `${publicUserData?.picture}` ||
                    `${publicUserData?.profile_image_url}`
                  }
                  className="rounded-full h-14 w-14"
                ></img>
              </div>
              <div className="ml-3 mt-2">
                <p className="text-base font-medium text-white">
                  {host_fullname}
                </p>
                <p className="text-sm font-medium text-[#D5D3D3] mt-1">
                  {language['plan_features']}:
                </p>
                {/* <p className="text-xs  text-[#D5D3D3] mt-1">
                  • {language['up_to']} {language['to_limit']} {publicUserData?.max_number_attendees ? publicUserData?.max_number_attendees : 50} {language['attendees']}.
                </p> */}
                <p className="text-xs  text-[#D5D3D3] mt-1">
                  {publicUserData?.live_videos ? (
                    <>• {language['ability_to_record']}</>
                  ) : (
                    <>• Can Not Record A Stream</>
                  )}
                </p>
                <p className="text-xs  text-[#D5D3D3] mt-1">
                  {parseInt(publicUserData?.max_presenters) !== 0 && !!parseInt(publicUserData?.max_presenters) ? (
                    <>• {language['ability_to_copresenter']}</>
                  ) : (
                    <>• Can Have Co-Presenters</>
                  )}
                </p>
                <p className="text-xs  text-[#D5D3D3] mt-1">
                    <>• Can Screen Share</>
                </p>
                <p className="text-xs  text-[#D5D3D3] mt-1">
                  • {language['up_to']} {language['to_limit']} {publicUserData?.max_meeting_length ? publicUserData?.max_meeting_length : 60} {language['minutes_value']}.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="w-full pl-2 pr-2  mt-5" cursor-pointer>
            <span className="text-sm  text-[#D5D3D3] ml-2.5 ">
              App Settings
            </span>
            <div className="flex cursor-pointer justify-between bg-[#222324] w-full rounded pl-3 pr-3 pt-4 pb-4 mt-2">
              <span className="text-xs text-white">
                Language:{" "}
                <span className="text-sx text-white font-semibold">
                  English
                </span>
              </span>
              <AiOutlineCaretDown color="B59EFF" size={20} cursor="pointer" />
            </div>
          </div>

          <div className="w-full pl-2 pr-2  mt-5">
            <span className="text-sm  text-[#D5D3D3] ml-2.5 ">
              {language['stream_settings']}
            </span>
            <div className="flex justify-between bg-[#222324] w-full rounded pl-3 pr-3 pt-4 pb-4 mt-2">
              <span className="text-xs text-white w-[70%]">
              {language['hide_attendee_list']}.
              </span>
              <div className="relative">
                <input
                  className="mr-2 mt-[0.3rem] h-3 w-8 appearance-none rounded-[0.4375rem] bg-[#473386] before:pointer-events-none before:absolute before:h-3 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-[#845DF8] after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-[#845DF8] checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault01"
                  checked={isShowTitle}
                  onChange={handleSwitchChange}
                />
              </div>
            </div>
          </div> */}

          <div style={{marginTop:'10px'}}>
            <MediaDeviceTest />
          </div>
          

          <div className="w-full pl-2 pr-2  mt-8 cursor-pointer">
            <div className="flex items-center justify-center bg-[#222324] w-full rounded  pt-4 pb-4 mt-2">
              <p
                className="text-sm font-medium"
                onClick={() => {
                  logoutWeb();
                }}
                style={{color: `${settingsBrandColor} `}}
              >
                {language['sign_out']}
              </p>
            </div>
          </div>

          <div className="w-full flex items-center justify-center pl-2 pr-2  mt-5">
            <span className="text-sm" style={{color: `${settingsBrandColor} `}}>
            <span className="cursor-pointer" onClick={handleEmailShare}>{language['questions_or_need_help']}?{" "}</span>
            </span>
          </div>

          <div className="w-full flex items-center justify-center pl-2 pr-2  mt-5">
            <span className="text-xs" style={{color: `${settingsBrandColor} `}}>
              <span className="font-black text-xs text-white">
                Hussle{" "}
                <span className="text-xs text-white font-normal">LIVE</span>
              </span>{" "}
              <span className="cursor-pointer" onClick={() => openNewTab(linksConstants.data_url)}>{(language['data_privacy_agreement'].charAt(0).toUpperCase() + language['data_privacy_agreement'].slice(1))}</span>,
            </span>
          </div>

          <div className="w-full flex items-center justify-center pl-2 pr-2  mt-1">
            <span className="text-xs" style={{color: `${settingsBrandColor} `}}>
            <span className="cursor-pointer" onClick={() => openNewTab(linksConstants.privacy_url)}>{(language['privacy_policy'].charAt(0).toUpperCase() + language['privacy_policy'].slice(1))}</span> <span className="text-xs text-white">{language['and']}</span>{" "}
            <span className="cursor-pointer" onClick={() => openNewTab(linksConstants.terms_url)}>{(language['terms_of_use'].charAt(0).toUpperCase() + language['terms_of_use'].slice(1))}.{" "}</span>
            </span>
          </div>

          <div className="w-full flex items-center justify-center pl-2 pr-2  mt-5 mb-5">
            <span className="text-xs  text-white">
              Hussle live 3.0 build 1.0{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsScreen;
